import { forwardRef, type ButtonHTMLAttributes } from 'react';
import type { IconData } from './icon-data.js';
import { Icon } from './Icon.js';
import { cx } from './util.js';

export interface IconButtonProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  icon: IconData;
  /** Required: an icon alone has no name for a screen reader. */
  label: string;
  variant?: 'standard' | 'tonal' | 'brand';
  /** For a toggle: pressed state. Omit for a plain action. */
  toggled?: boolean;
}

export const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(function IconButton(
  { icon, label, variant = 'standard', toggled, className, type = 'button', ...rest },
  ref,
) {
  return (
    <button
      {...rest}
      ref={ref}
      type={type}
      aria-label={label}
      aria-pressed={toggled}
      className={cx(
        'k-iconbtn k-layer',
        `k-iconbtn--${variant}`,
        toggled && 'k-iconbtn--on',
        className,
      )}
    >
      <Icon icon={icon} />
    </button>
  );
});
